import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Password } from "primereact/password";
import { FC, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ProgressSpinner } from "primereact/progressspinner";
import { AuthService } from "../../service/AuthService";
import { validateEmail, validatePassword } from "../../helpers/auth";

export interface ILogin {
    email: string;
    password: string;
}

export const LoginPage: FC = () => {
    const navigate = useNavigate();
    const [state, setState] = useState<ILogin>({
        email: "",
        password: ""
    });
    const [disableSubmitButton, setDisableSubmitButton] = useState<boolean>(true);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        let isValid = true;
        
        isValid = validateEmail(state.email) && validatePassword(state.password);

        setDisableSubmitButton(!isValid);
    }, [state.password, state.email]);

    const onSubmit = async () => {
        setIsLoading(true);
        await AuthService.login(state).then((response) => {
            if (response) {
                localStorage.setItem("accessToken", response.AuthenticationResult?.IdToken);
                navigate("/settings");
            }
        });
        setIsLoading(false);
    };

    return (
        <div className="relative flex flex-wrap align-items-center justify-content-center h-screen">
            <div className="vertical-align-middle border-transparent shadow-2 p-5 w-4">
                <h2 className="text-center">Sign In</h2>
                <div className="p-inputgroup flex-1 w-full mt-4">
                    <label className="p-inputgroup-addon" htmlFor="email">
                        <i className="pi pi-user"></i>
                    </label>
                    <InputText
                        placeholder="Email"
                        onChange={(e) => setState({ ...state, email: e.target.value as string })}
                        value={state.email}
                        id="login-email"
                        name="login-email"
                    />
                </div>
                <div className="p-inputgroup flex-1 mt-4 w-100">
                    <label className="p-inputgroup-addon" htmlFor="password">
                        <i className="pi pi-lock"></i>
                    </label>
                    <Password
                        value={state.password}
                        feedback={false}
                        tabIndex={1}
                        placeholder="Password"
                        toggleMask
                        onChange={(e) => setState({ ...state, password: e.target.value as string })}
                        id="login-password"
                        name="login-password"
                    />
                </div>
                <div className="w-100 flex justify-content-center mt-4">
                    <Button
                        label="Submit"
                        className="w-full"
                        onClick={onSubmit}
                        disabled={disableSubmitButton}
                    />
                </div>
                <div className="flex flex-column align-items-start gap-2 pt-4 text-sm w-full">
                    <div className="flex align-items-center py-1 gap-1 h-1rem w-full">
                        <p>Don't have an account?</p>
                        <Button
                            label="Sign Up"
                            link
                            onClick={() => navigate("/register")}
                            className="text-sm p-0"
                        />
                    </div>
                    <div className="flex align-items-center py-1 gap-1 h-1rem w-full">
                        <p>Forgot your password?</p>
                        <Button
                            label="Reset password"
                            link
                            onClick={() => navigate("/reset-password")}
                            className="text-sm p-0"
                        />
                    </div>
                </div>
            </div>
            {isLoading && (
                <div className="absolute">
                    <ProgressSpinner />
                </div>
            )}
        </div>
    );
};
